export default function HowItWorksSection() {
  const steps = [
    {
      step: '01',
      icon: 'ri-search-eye-line',
      title: 'Discover Products',
      description: 'Browse through organized spreadsheets to find products across multiple categories',
    },
    {
      step: '02',
      icon: 'ri-scales-3-line',
      title: 'Compare Information',
      description: 'Review detailed product data, quality notes, and category comparisons side by side',
    },
    {
      step: '03',
      icon: 'ri-file-search-line',
      title: 'Research Quality',
      description: 'Access curated guides and tips to evaluate product quality and seller reliability',
    },
    {
      step: '04',
      icon: 'ri-check-double-line',
      title: 'Choose the Best',
      description: 'Select the most suitable options based on organized, verified product data',
    },
    {
      step: '05',
      icon: 'ri-shopping-bag-3-line',
      title: 'Shop Confidently',
      description: 'Continue your shopping journey through trusted, verified platforms with confidence',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
            Getting Started
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            How Hipobuy Spreadsheet Works
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            Five simple steps to transform your shopping research experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {steps.map((item, idx) => (
            <div key={idx} className="relative group">
              <div className="bg-background-50 rounded-2xl p-5 md:p-6 h-full border border-background-200/70 hover:border-primary-200 transition-colors duration-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="text-xs font-bold text-primary-400 mb-2">{item.step}</div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-arrow-right-s-line text-accent-600 text-sm"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}